import ProductType from "../dtos/product.types";

import styles from "../styles/HomeProducts.module.scss";

import residencial from "../../public/svg/produtos/residencialProduto.svg"
import bike from "../../public/svg/produtos/bikeProduto.svg"
import auto from "../../public/svg/produtos/autoProduto.svg"
import empresarial from "../../public/svg/produtos/empresarialProduto.svg"
import odontologico from "../../public/svg/produtos/odontologicoProduto.svg"
import vida from "../../public/svg/produtos/vidaProduto.svg"

import Link from "next/link";

type Props = {
  dataProd: ProductType
}

const HomeProducts = ({ dataProd }: Props) => {

  const content =
    dataProd.id == 'residencial'
      ? <img src={residencial} alt={"Celular com casa representando a contratação do Seguro Residencial do Madaseg pelo celular e web."} />
      : dataProd.id == 'bike' ? <img src={bike} alt={"Rapaz sobre uma bicicleta que sai da tela de celular como referência ao Seguro Bike do Madaseg"} />
        : dataProd.id == 'vida' ? <img src={vida} alt={"Celular em destaque com ícone de um coração na tela para representar o Seguro Vida do Madaseg"} />
          : dataProd.id == 'empresarial' ? <img src={empresarial} alt={"Celular em destaque com ícone de empresa sobre ele para representar o Seguro Empresarial do Madaseg"} />
            : dataProd.id == 'odontologico' ? <img src={odontologico} alt={"Celular em destaque com ícone de um dente na tela para citar o Seguro Odontológico do Madaseg"} />
              : <img className="-mt-5 mb-5" src={auto} alt={"Carro em cima da tela de celular para citar o Seguro Auto do Madaseg"} />

  return (
    <section id="homeProduto">
      <div className="dlg:grid dlg:h-screen dlg:grid-cols-2 dlg:mt-0 mt-36 flex flex-col-reverse relative items-center content-center">
        <div className="dlg:place-self-center place-self-start -ml-5 lg:pt-24">
          <div className="mx-auto px-6 dlg:px-0 mt-12 dlg:mt-0 dlg:max-w-dlg">
            <div>
              <span className={styles.compTitulo}>
                {dataProd.compTitulo}
              </span>
              <span className={styles.titulo}>{dataProd.titulo}</span>
            </div>
            <div className="flex flex-col mt-3">
              <span className={styles.fraseUm}>{dataProd.frases.um}</span>
              <span className={styles.fraseDois}>{dataProd.frases.dois}</span>
            </div>
            {dataProd.id == 'auto' ?
              <div className={styles.areaValor}><span className={styles.textAuto}>{dataProd.valor}</span></div> :
              <div className={styles.areaValor}>
                <span className={styles.cifrao}>R$</span>
                <span className={styles.valor}>{dataProd.valor}</span>
                <div className={styles.areaZeroMensal}>
                  <span className={styles.zeroZero}>,00</span>
                  <span className={styles.mensais}>/mensais</span>
                </div>
              </div>
            }
            <div className="flex flex-col dlg:mt-3 mt-5">
              <span className={styles.fraseTres}>{dataProd.frases.tres}</span>
              <span className={styles.fraseQuatro}>{dataProd.frases.quatro}</span>
            </div>
            <div className="dlg:mt-12 mt-8">
              {dataProd.id == "odontologico" ?
                <button className={styles.btnContrate}>em breve</button>
                : <Link href={`${process.env.NEXT_PUBLIC_HOST}${dataProd.rota}`}><button className={styles.btnContrate}>{dataProd.button}</button></Link>
              }
            </div>
          </div>
        </div>
        <div className="2xl:w-11/12 w-4/5 place-self-center lg:pt-24">
          {content}
        </div>
      </div>
    </section>
  );
};
export default HomeProducts;

